module.exports = __webpack_public_path__ + "static/media/close.b8421e08.svg";